export { default as TableNotasFiscaisNav } from "./TableNotasFiscaisNav"
export { default as TableNotasFiscais } from "./TableNotasFiscais"
export { default as NotasFiscais } from "./NotasFiscais"
export { default as NotasFiscaisEditForm } from "./NotasFiscaisEditForm"
export { default as NotasFiscaisTrash } from "./NotasFiscaisTrash"
export { default as TableNotasFiscaisTrash } from "./TableNotasFiscaisTrash"



// WEBPACK FOOTER //
// ./src/views/baixas/index.js